const Footer = () => {
  return (
    <footer className='bg-spring-wood-100 py-3 mt-10 text-sm md:text-base h-[50px flex flex-row justify-center items-center'>
      Built in React and Typescript by&nbsp;
      <a
        href='https://github.com/jjmountain'
        target='_blank'
        rel='noreferrer'
        className='underline'
      >
        @jjmountain
      </a>
      &nbsp;and&nbsp;
      <a
        href='https://github.com/mmoses1127'
        target='_blank'
        rel='noreferrer'
        className='underline'
      >
        @mmoses1127
      </a>
    </footer>
  )
}

export default Footer
